// extracted by mini-css-extract-plugin
export default {"arrow":"ArrowButton-module--arrow--BG1ge","next":"ArrowButton-module--next--nQxZc","prev":"ArrowButton-module--prev--XOCuw"};